import { Tooltip } from "react-tooltip";

import { AssetModel } from "@interfaces/models";
import { AssetItem } from "@components/index";

export const SearchAssetItem = ({
  asset,
  onDetails,
}: {
  asset: AssetModel;
  onDetails: () => void;
}) => (
  <>
    <div
      className="flex cursor-pointer flex-col gap-y-0.5 px-6 py-2 hover:bg-black-4"
      onClick={onDetails}
      data-tooltip-id={`tooltip-asset-${asset.uniqueId}`}
      data-tooltip-content={asset.uniqueId}
      data-tooltip-variant="dark"
    >
      <AssetItem type={asset.type} name={asset.name} />
    </div>
    <Tooltip id={`tooltip-asset-${asset.uniqueId}`} />
  </>
);
